import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminThemeContext = createContext();

export const AdminThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('adminTheme') === 'dark';
  });

  useEffect(() => {
    localStorage.setItem('adminTheme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const toggleTheme = () => setDarkMode(!darkMode);

  // Theme classes
  const theme = {
    bg: darkMode ? 'bg-slate-900' : 'bg-gray-50',
    sidebar: darkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200',
    header: darkMode ? 'bg-slate-800/90 border-slate-700' : 'bg-white/90 border-gray-200',
    card: darkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-100 shadow-sm',
    text: darkMode ? 'text-white' : 'text-gray-900',
    textMuted: darkMode ? 'text-slate-400' : 'text-gray-500',
    textSecondary: darkMode ? 'text-slate-300' : 'text-gray-600',
    hover: darkMode ? 'hover:bg-slate-700' : 'hover:bg-gray-100',
    active: darkMode ? 'bg-blue-600/20 text-blue-400 border-blue-500/30' : 'bg-blue-50 text-blue-600 border-blue-200',
    input: darkMode ? 'bg-slate-700 border-slate-600 text-white placeholder:text-slate-400' : 'bg-gray-50 border-gray-200 text-gray-900 placeholder:text-gray-400',
    table: darkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200',
    tableRow: darkMode ? 'border-slate-700 hover:bg-slate-700/50' : 'border-gray-100 hover:bg-gray-50',
    tableHead: darkMode ? 'text-slate-300 bg-slate-700/50' : 'text-gray-600 bg-gray-50',
    dropdown: darkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200',
    badge: {
      blue: darkMode ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-100 text-blue-700',
      green: darkMode ? 'bg-emerald-500/20 text-emerald-400' : 'bg-emerald-100 text-emerald-700',
      yellow: darkMode ? 'bg-amber-500/20 text-amber-400' : 'bg-amber-100 text-amber-700',
      purple: darkMode ? 'bg-purple-500/20 text-purple-400' : 'bg-purple-100 text-purple-700',
      red: darkMode ? 'bg-red-500/20 text-red-400' : 'bg-red-100 text-red-700',
    }
  };

  return (
    <AdminThemeContext.Provider value={{ darkMode, setDarkMode, toggleTheme, theme }}>
      {children}
    </AdminThemeContext.Provider>
  );
};

export const useAdminTheme = () => {
  const context = useContext(AdminThemeContext);
  if (!context) {
    throw new Error('useAdminTheme must be used within AdminThemeProvider');
  }
  return context;
};
